import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    applyFilterByMainKeyAndSlug,
    clearAllFilter,
    clearFilterByKeyAndSelectionIndex
} from "../../../../store/slice/ProductListingFilterApplied";
import Product from "@system/config/product";
import $ from "jquery";
import System from "src/helper/system";
import { isObject } from "underscore";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';

const ProductDetailDescriptionTab = (props) => {
    const dispatch = useDispatch();
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const [productData, setProductData] = useState([]);
    const [ECCNData, setECCNData] = useState([]);
    const [ascDesField, setAscDesField] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const inventory = inventoryList;
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const filter = useSelector((state) => state.entities.ProductListingFilterApplied)

    /*
     * Technical Attributes:
     * Check empty ATTRVAL
     *
     * null / undefined / "" / whitespace
     */
    const isEmptyAttributeValue = (value) => {
        return (
            value === null ||
            value === undefined ||
            String(value).trim() === ''
        );
    };

    /*
     * Technical Attributes:
     * Default sorting by SEQUENCE ASC
     */
    const sortBySequence = (data) => {
        return [...data].sort((a, b) => {
            const aSequence = Number(a?.SEQUENCE);
            const bSequence = Number(b?.SEQUENCE);

            /*
             * Missing/invalid sequence should be at bottom
             */
            if (
                Number.isNaN(aSequence) &&
                Number.isNaN(bSequence)
            ) {
                return 0;
            }

            if (Number.isNaN(aSequence)) {
                return 1;
            }

            if (Number.isNaN(bSequence)) {
                return -1;
            }

            return aSequence - bSequence;
        });
    };

    const setFilterBoxForField = (element) => {
        /*
         * Empty ATTRVAL should not be selectable
         */
        if (isEmptyAttributeValue(element?.ATTRVAL)) {
            return;
        }

        let d = getAppliedFilterStatusByValue(element.ATTRNAME, element.ATTRVAL);
        if (!d) {
            applyFilterByMainKeyAndSlugInternal(element);
        } else {
            dispatch(clearFilterByKeyAndSelectionIndex({
                    key: System.anythingToCamel(element.ATTRNAME),
                    selectionIndex: d.i,
                }))
        }
    };

    const getAppliedFilterStatusByValue = (name, value) => {
        let slug = System.anythingToCamel(name);
        if (filter[slug] && filter[slug].selection &&
            filter[slug].selection.length
        ) {
            let decision = false;
            filter[slug].selection.map((v, i) => {
                if (v.value === value) {
                    decision = {
                        v, i
                    };
                }
            })
            return decision;
        }
        return false;
    };

    const applyFilterByMainKeyAndSlugInternal = (element) => {
        /*
         * Empty ATTRVAL should never be added to filter
         */
        if (isEmptyAttributeValue(element?.ATTRVAL)) {
            return;
        }

        dispatch(applyFilterByMainKeyAndSlug({
                key: System.anythingToCamel(element.ATTRNAME),
                main_label: element.ATTRNAME,
                value: element.ATTRVAL,
            }))
    }
    const toggleAllSelection = () => {
        const selectableRows = productData.filter(
            (item) =>
                !isEmptyAttributeValue(
                    item?.ATTRVAL
                )
        );

        let status = !getMainSelectionStatus();
        if (status) {
            if (selectableRows.length) {
                selectableRows.map((v) => {
                    applyFilterByMainKeyAndSlugInternal(v);
                });
            }
        } else {
            dispatch(clearAllFilter())
        }
    };
    const getMainSelectionStatus = () => {
        let activeFilterCount = 0;
        let productDetailCount = 0;

        if (productDetail?.value?.Attributes &&
            productDetail.value.Attributes.length > 0) {
            /*
             * Only selectable rows
             */
            const selectableRows = productDetail.value.Attributes.filter((v) =>!isEmptyAttributeValue(v?.ATTRVAL));

            productDetailCount = selectableRows.length;
            selectableRows.map((v) => {
                if (getAppliedFilterStatusByValue(v.ATTRNAME,v.ATTRVAL)) {
                    activeFilterCount++;
                }
            });
        }
        return (
            productDetailCount > 0 &&
            activeFilterCount === productDetailCount);
    };
    const goToProductListing = () => {
        window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
                go: System.getParams().go,
                appendFacadeOptions: 'yes'
            });
    };

    useEffect(() => {
        if (productDetail?.value?.Attributes && productDetail.value.Attributes.length > 0) {
            setProductData(sortBySequence(productDetail.value.Attributes));

            /*
             * Reset Technical Attributes sorting
             */
            setSortBy('');
            setSortOrder('');
            setAscDesField({});
        } else {
            setProductData([]);
        }

        if (productDetail?.value) {
            let ECCNInfo = [];
            if (productDetail.value?.sap_originating_countryoforigin) {
                const ECCNObj = {
                    Name: "Country of Origin",
                    Value: productDetail.value.sap_originating_countryoforigin
                };
                ECCNInfo.push(ECCNObj);
            }

            if (productDetail.value.ECCNCode && productDetail.value.ECCNCode.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'ECCN'
                ECCNObj.Value = productDetail.value.ECCNCode
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.HTSCode && productDetail.value.HTSCode.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'COMMODITY CODE'
                ECCNObj.Value = productDetail.value.HTSCode
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.UNSPSC && productDetail.value.UNSPSC.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'UNSPSC'
                ECCNObj.Value = productDetail.value.UNSPSC
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.UNSPSCVersion && productDetail.value.UNSPSCVersion.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'UNSPSC VERSION'
                ECCNObj.Value = productDetail.value.UNSPSCVersion
                ECCNInfo.push(ECCNObj)
            }

            setECCNData(ECCNInfo)
        }


    }, [productDetail]);

    const sortAttributes = (columnName) => {
        const isECCNColumn = columnName === 'Name' || columnName === 'Value';

        const Attributes = isECCNColumn ? [...ECCNData] : [...productData];

        const currentOrder = ascDesField[columnName];

        /*
         * Only Technical Attributes:
         *
         * DESC -> reset to SEQUENCE ASC
         */
        if (
            !isECCNColumn &&
            currentOrder === 'DESC'
        ) {
            setSortBy('');
            setSortOrder('');
            setAscDesField({});

            setProductData(
                sortBySequence(Attributes)
            );

            return;
        }

        /*
         * Existing ECCN sorting logic
         */
        if (
            ascDesField.hasOwnProperty(columnName)
        ) {
            const newOrder =
                ascDesField[columnName] === 'ASC'
                    ? 'DESC'
                    : 'ASC';

            setAscDesField((prev) => ({
                ...prev,
                [columnName]: newOrder,
            }));

            setSortBy(columnName);
            setSortOrder(newOrder);

            let AttributesSorted = [];

            if (newOrder === 'ASC') {
                AttributesSorted = Attributes.sort(
                    (a, b) =>
                        b[columnName] <
                        a[columnName]
                            ? -1
                            : 1
                );
            } else {
                AttributesSorted = Attributes.sort(
                    (a, b) =>
                        b[columnName] >
                        a[columnName]
                            ? -1
                            : 1
                );
            }

            if (isECCNColumn) {
                setECCNData(AttributesSorted);
            } else {
                setProductData(AttributesSorted);
            }

            return;
        }

        /*
         * First click -> ASC
         */
        setAscDesField((prev) => ({
            ...prev,
            [columnName]: 'ASC',
        }));

        setSortBy(columnName);
        setSortOrder('ASC');

        let AttributesSorted = Attributes.sort(
            (a, b) =>
                b[columnName] <
                a[columnName]
                    ? -1
                    : 1
        );

        if (isECCNColumn) {
            setECCNData(AttributesSorted)
        } else {
            setProductData(AttributesSorted)
        }
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)
        ) {
            return (
                'sorting sorting_' +
                ascDesField[
                    columnName
                ].toLowerCase()
            );
        }

        return 'sorting'
    };

    //By Ramya Kannan [Product view - Adobe script ]

    const [isProdViewEvent, setProdViewEvent] = useState(true)
    useEffect(() => {
        let checkCon = productDetail?.value && isProdViewEvent && Object.keys(inventory).length && System.checkPriceValues(pricingList);
        if (checkCon) {
            prodViewEvent();
            setProdViewEvent(false)
        }
    }, [productDetail, inventory, pricingList])


    function prodViewEvent() {
        localStorage.setItem("adobeEventType", "productViewEvent");
        let prodDetails = { ...productDetail?.value };
        prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
        prodDetails.priceSource = getPricing(
                prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
                prodDetails.ERPPartNumber,
                prodDetails.ERPPartNumberModified
            )[0]?.priceSource;

        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
        }
    }


    //added by Ramya [Adobe script]
    const getInventory = (ERPPartNumber) => {
        if (inventory[ERPPartNumber] !== undefined) {
            return inventory[ERPPartNumber];
        }
        return {
            qas: 0,
            quantity: 0,
        };
    };
    const getPricing = (
        ERPMFRPartNumber,
        ERPPartNumber,
        ERPPartNumberModified
    ) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
    };



    return (
        <>
            <div className="tab-pane active" id="tab1">
                <div className="productdetail-description">
                    {(productDetail?.value?.LongDescription && productDetail.value.LongDescription.trim() !== '') ?
                        <p className="mob-font-13 mb-2"
                            dangerouslySetInnerHTML={{ __html: productDetail.value.LongDescription }}></p> : ''}

                    {(productDetail?.value?.ProductFeatures && productDetail.value.ProductFeatures.trim() !== '') ?
                        <p className="mob-font-13 mb-2"
                            dangerouslySetInnerHTML={{ __html: productDetail.value.ProductFeatures }}></p> : ''}
                </div>

                {productData && productData.length > 0 && (
                        <div>
                            <h4 className="mb-2 mt-0">Technical Attributes</h4>
                            <p className="text-sm">Find Similar Parts</p>
                            {productDetail?.value?.Attributes &&
                            productDetail.value.Attributes.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="bs5 table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w35 font-12">
                                                    <div className="form-check d-flex align-items-center font-18">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input me-1"
                                                            id="productDetailAttribute"
                                                            checked={getMainSelectionStatus()}
                                                            disabled={
                                                                !productData.some(
                                                                    (item) =>
                                                                        !isEmptyAttributeValue(
                                                                            item?.ATTRVAL
                                                                        )
                                                                )
                                                            }
                                                            onChange={() => {
                                                                toggleAllSelection();
                                                            }}
                                                        />
                                                        <label className="form-check-label"
                                                            htmlFor="productDetailAttribute" />
                                                    </div>
                                                </th>
                                                <th><span>Description</span>
                                                    <span
                                                        className={
                                                            'sort-container ' +
                                                            getOrderByClass(
                                                                'ATTRNAME'
                                                            )
                                                        }
                                                        onClick={() => {
                                                            sortAttributes(
                                                                'ATTRNAME'
                                                            );
                                                        }}
                                                    ></span>
                                                </th>

                                                <th>
                                                    <span>
                                                        Value
                                                    </span>

                                                    <span
                                                        className={
                                                            'sort-container ' +
                                                            getOrderByClass(
                                                                'ATTRVAL'
                                                            )
                                                        }
                                                        onClick={() => {
                                                            sortAttributes(
                                                                'ATTRVAL'
                                                            );
                                                        }}
                                                    ></span>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {productData.map(
                                                (
                                                    element,
                                                    index
                                                ) => {
                                                    const valueIsEmpty =
                                                        isEmptyAttributeValue(
                                                            element?.ATTRVAL
                                                        );

                                                    const isSelected =
                                                        !valueIsEmpty &&
                                                        !!getAppliedFilterStatusByValue(
                                                            element.ATTRNAME,
                                                            element.ATTRVAL
                                                        );

                                                    return (
                                                        <tr
                                                            key={
                                                                index
                                                            }
                                                        >
                                                            <td>
                                                                <div className="form-check d-flex align-items-center font-18">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input me-1"
                                                                        id={
                                                                            index +
                                                                            'Row_Filter'
                                                                        }
                                                                        checked={
                                                                            isSelected
                                                                        }
                                                                        disabled={
                                                                            valueIsEmpty
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            setFilterBoxForField(
                                                                                element
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={
                                                                        index +
                                                                        'Row_Filter'
                                                                    }
                                                                >
                                                                    {element.ATTRNAME &&
                                                                    String(
                                                                        element.ATTRNAME
                                                                    ).trim() !== ''
                                                                        ? element.ATTRNAME
                                                                        : '-'}
                                                                </label>
                                                            </td>

                                                            <td>
                                                                {!valueIsEmpty
                                                                    ? element.ATTRVAL
                                                                    : '-'}
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                ''
                            )}

                            <button
                                disabled={
                                    !(
                                        isObject(
                                            filter
                                        ) &&
                                        Object.entries(
                                            filter
                                        ).length > 0
                                    )
                                }
                                onClick={() => {
                                    goToProductListing();
                                }}
                                className={
                                    !(
                                        isObject(
                                            filter
                                        ) &&
                                        Object.entries(
                                            filter
                                        ).length > 0
                                    )
                                        ? 'bs5 btn btn-secondary mt-2 mb-4 disabled'
                                        : 'bs5 btn btn-secondary mt-2 mb-4'
                                }
                            >
                                find similar parts
                            </button>
                        </div>
                    )}

                <div className="mt-1">
                    {ECCNData  && ECCNData.length > 0 &&
                            <>
                            <h4 className="mb-3 mt-0"> ECCN/Commodity Code</h4>
                            <div className='table-respnsive'>
                                    <table className="bs5 table table-bordered">
                                        <thead>
                                            <tr>
                                            <th><span>Description</span>
                                                <span className={'sort-container ' +
                                                    getOrderByClass('Name')
                                                        }
                                                        onClick={() => {
                                                        sortAttributes('Name')
                                                    }}></span>
                                                </th>
                                            <th><span>Value</span>
                                                <span className={'sort-container ' +
                                                    getOrderByClass('Value')
                                                        }
                                                        onClick={() => {
                                                        sortAttributes('Value')
                                                    }}></span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            ECCNData.map((v, i) => (
                                                <tr key={i}>
                                                    <td>{v.Name}:</td>
                                                    <td>{v.Value}</td>
                                                    </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </>
                    }

                </div>
            </div>
        </>
    );
}

export default ProductDetailDescriptionTab;